"use client";

import type { FC } from "react";
import { cn } from "utils";
import { SIGN_IN_PAGE_COPY } from "../signInPageCopy";

interface SignInOrContinueLabelProps {
  label?: string;
  className?: string;
}

/** Figma「or continue with」— 纯文案，无分割线（D19）。 */
export const SignInOrContinueLabel: FC<SignInOrContinueLabelProps> = ({
  label = SIGN_IN_PAGE_COPY.orContinueWith,
  className,
}) => (
  <p
    className={cn(
      "w-full text-center body_medium_s text-content_secondary",
      className,
    )}
  >
    {label}
  </p>
);
